module.exports = __webpack_public_path__ + "static/media/0001.a862e971.jpg";